export type formatAddressProps = {
    firstLine?: string;
    secondLine?: string;
    zipCode?: string;
    city?: string;
};

export const formatAddress = ({ firstLine, secondLine, zipCode, city }: formatAddressProps) => {
    if (!firstLine && !zipCode && !city) return 'Adresse Inconnue ou Incomplète';

    let formattedAddress = firstLine;

    if (secondLine && secondLine.trim() !== '') {
        formattedAddress += `, ${secondLine}`;
    }

    formattedAddress += `, ${zipCode} ${city}`;

    return formattedAddress;
};

export default formatAddress;
